export default __webpack_public_path__ + "4277bdba95df3017f4775ac046e64361.svg";